export const OTHERGOODS_EXPENSES_REQUEST = "OTHERGOODS_EXPENSES_REQUEST";
export const OTHERGOODS_EXPENSES_SUCCESS = "OTHERGOODS_EXPENSES_SUCCESS";
export const OTHERGOODS_EXPENSES_FAILED = "OTHERGOODS_EXPENSES_FAILED";
